<template lang="pug">
	div.contenedorCalendario
		.controles
			.avance
				.btn-group.mr-2
					button.btn(@click="anterior")
						span.fa.fa-caret-left
					button.btn(@click="siguiente")
						span.fa.fa-caret-right
				button.btn.mr-2 Hoy
			.fechaActual
				span {{ fecha | moment('MMMM, YYYY')}}
			.modos
				.btn-group
					button.btn
						span Mes
					button.btn
						span Semana
					button.btn
						span Día
		.calendario
			Mes(:fecha="fecha", :eventos="eventos")
</template>

<script>
import Mes from './mes.component'
export default {
	components: {
		Mes
	},
	data () {
		return {
			fecha: new Date(),
			eventos: [
				{
					component: 'editor-producciones',
					titulo: 'Grabación',
					descripcion: 'Grabación speech noticia',
					inicio: new Date(2020, 0, 6, 12, 0, 0),
					fin: new Date(2020, 0, 6, 13, 0, 0)
				},
				{
					component: 'editor-producciones',
					titulo: 'Grabación',
					descripcion: 'Grabación speech noticia',
					inicio: new Date(2020, 0, 8, 12, 0, 0),
					fin: new Date(2020, 0, 8, 13, 0, 0)
				},
				{
					component: 'editor-producciones',
					titulo: 'Grabación 2',
					descripcion: 'Grabación speech noticia',
					inicio: new Date(2020, 0, 10, 12, 0, 0),
					fin: new Date(2020, 0, 10, 13, 0, 0)
				},
				{
					component: 'editor-producciones',
					titulo: 'Grabación 2',
					descripcion: 'Grabación speech noticia',
					inicio: new Date(2020, 0, 12, 12, 0, 0),
					fin: new Date(2020, 0, 12, 13, 0, 0)
				},
				{
					component: 'editor-producciones',
					titulo: 'Grabación',
					descripcion: 'Grabación speech noticia',
					inicio: new Date(2020, 0, 14, 12, 0, 0),
					fin: new Date(2020, 0, 14, 13, 0, 0)
				},
				{
					component: 'editor-producciones',
					titulo: 'Grabación',
					descripcion: 'Grabación speech noticia',
					inicio: new Date(2020, 0, 16, 12, 0, 0),
					fin: new Date(2020, 0, 16, 13, 0, 0)
				},
				{
					component: 'editor-producciones',
					titulo: 'Grabación 2',
					descripcion: 'Grabación speech noticia',
					inicio: new Date(2020, 0, 18, 12, 0, 0),
					fin: new Date(2020, 0, 18, 13, 0, 0)
				}
			]
		}
	},
	methods: {
		siguiente () {
			this.fecha = new Date(this.fecha.getFullYear(), this.fecha.getMonth() + 1, 1)
			this.$emit('fecha', this.fecha)
		},
		anterior () {
			this.fecha = new Date(this.fecha.getFullYear(), this.fecha.getMonth() - 1, 1)
			this.$emit('fecha', this.fecha)
		}
	}
}
</script>

<style scoped>
.contenedorCalendario {
	background-color: white;
	margin: 10px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	display: flex;
	width: calc(100% - 20px);
	flex-direction: column;
	padding: 10px;
}

.controles {
	display: flex;
	flex-direction: row;
	width: 100%;
	align-content: flex-start;
	align-self: center;
	align-items: flex-start;
	font-size: 1.3em;
}

.avance {
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 200px;
}

.fechaActual {
	flex-grow: 1;
	flex-shrink: 1;
	text-align: center;
	text-transform: uppercase;
	font-weight: bold;
	align-self: center;
}

.modos {
	text-align: right;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 100px;
}
.calendario {
	margin-top: 20px;
	padding-top: 20px;
	border-top: 1px solid #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/modulos/produccion-audiovisual/vue/components/overview/calendario.component.vue